import { createTypes, createAction } from 'lib/action'

const CASCADER_DIVISION = createTypes('load', 'cascaderDivision') //cascaderDivision
const CASCADER_DEPARTMENT = createTypes('load', 'cascaderDepartment') //cascaderDepartment
const CASCADER_SECTION = createTypes('load', 'cascaderSection') //cascaderSection
const CASCADER_PLANT = createTypes('load', 'cascaderPlant')

const SET_FILTER_OBJECT = 'SET_FILTER_OBJECT'

const CASCADER_OPTION = createTypes('load', 'cascaderOption')

// ตัวเลือกทั้งหมด
const cascaderLoadOption = {
  request: (data, loading) =>
    createAction(CASCADER_OPTION.REQUEST, { data, loading }),
  success: (data) => createAction(CASCADER_OPTION.SUCCESS, { data }),
  failure: () => createAction(CASCADER_OPTION.FAILURE),
}

// กิจการ
const cascaderLoadDivision = {
  request: (data, loading) =>
    createAction(CASCADER_DIVISION.REQUEST, { data, loading }),
  success: (lists) => createAction(CASCADER_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(CASCADER_DIVISION.FAILURE),
}

// ฝ่าย/ส่วน
const cascaderLoadDepartment = {
  request: (data, loading) =>
    createAction(CASCADER_DEPARTMENT.REQUEST, { data, loading }),
  success: (lists) => createAction(CASCADER_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(CASCADER_DEPARTMENT.FAILURE),
}

// แผนก
const cascaderLoadSection = {
  request: (data, loading) =>
    createAction(CASCADER_SECTION.REQUEST, { data, loading }),
  success: (lists) => createAction(CASCADER_SECTION.SUCCESS, { lists }),
  failure: () => createAction(CASCADER_SECTION.FAILURE),
}

const cascaderLoadPlant = {
  request: (data, requestId) =>
    createAction(CASCADER_PLANT.REQUEST, { data, requestId }),
  success: (lists, requestId) =>
    createAction(CASCADER_PLANT.SUCCESS, { lists, requestId }),
  failure: (requestId) => createAction(CASCADER_PLANT.FAILURE, { requestId }),
}

// รับ filterObj มา set ค่าลงใน redux store
const setFilterObject = (filterObj) => ({
  type: 'SET_FILTER_OBJECT',
  payload: filterObj,
})

export {
  CASCADER_DIVISION,
  CASCADER_DEPARTMENT,
  CASCADER_SECTION,
  CASCADER_PLANT,
  cascaderLoadDivision,
  cascaderLoadDepartment,
  cascaderLoadSection,
  cascaderLoadPlant,
  setFilterObject,
  SET_FILTER_OBJECT,
  CASCADER_OPTION,
  cascaderLoadOption,
}
